import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import ComisionComponent from "../../../components/comisiones/comisionesPagadas/ComisionesPagadas";
import {
  ComisionesPagadasStore,
  comisionesPagadasStore
} from "./ComisionesPagadas.store";
import {
  ComisionesPagadasDispatcher,
  comisionesPagadasDispatcher
} from "./ComisionesPagadas.dispatcher";
import Layout from "../../../components/layout";

interface Props extends ComisionesPagadasStore, ComisionesPagadasDispatcher {}
interface State {}

@Router()
@ReduxConnect(comisionesPagadasStore, comisionesPagadasDispatcher)
export default class ComisionContainer extends Component<Props, State> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Comisiones Pagadas - Talento y Cultura" />
          <ComisionComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
